import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import ClearIcon from "@mui/icons-material/Clear";
import AddUser from "../components/add_user";
import Content from "../components/content";
import Loader from "../components/loader";
import ModalUpgrade from "../components/modal_upgrade";
import Toast from "../components/toast";
import GenericModal from "../components/generic_modal";

import Button from "@mui/material/Button";
import FormControl, { useFormControl } from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Modal from "@mui/material/Modal";
import Select from "@mui/material/Select";
import Tooltip from "@mui/material/Tooltip";
import BasicTitle from "../components/title";

import { useImpersonation } from "../global/impersonation";

import { DataGrid } from "@mui/x-data-grid";

import DownloadIcon from "@mui/icons-material/Download";
import { IconButton, TextField, CircularProgress } from "@mui/material";
import EditUser from "../components/edit_user";
import ErrorModal from "../components/error_modal";
import Api from "../libs/api";
import Storage from "../libs/storage";
import ModalUserLimit from "../components/modal_user_limit";

const Holder = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    overflow: auto;
`;

const Filters = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 56px;
`;

const LeftFilters = styled.div`
    min-width: 100px;
    display: flex;
    align-items: center;
`;

const RightFilters = styled.div`
    min-width: 100px;
    display: flex;
    align-items: center;
`;

const Tag = styled.div`
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    text-align: center;
    text-transform: capitalize;
    padding: 4px 10px;
    border-radius: 8px;

    &.pendente {
        color: #181122;
        border: 1px solid #181122;
    }
    &.aprovado {
        color: #57c4c2;
        border: 1px solid #57c4c2;
    }
    &.rejeitado {
        color: #de6061;
        border: 1px solid #de6061;
    }
    &.pago {
        color: #57c4c2;
        border: 1px solid #57c4c2;
    }
`;

const Data = styled.div`
    margin-bottom: 40px;
`;

const ImageClickable = styled.img`
    cursor: pointer;
`;

const Vision = styled.div`
    margin-bottom: 40px;
    margin-top: 24px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;

    @media (max-width: 1130px) {
        flex-direction: column;
        align-items: flex-start ;
    }
`;

const VisionBoxCard = styled.div`
    display: flex;
    gap: 16px;

    @media (max-width: 745px) {
        flex-direction: column;
        width: 100%;
    }
`;

const PendingPaymentBox = styled.div`
    display: flex;
    padding: 12px 16px;
    align-items: center;
    gap: 12px;
    align-self: stretch;
    border-radius: 10px;
    border: 1px solid #cd8200;
    background: #efede8;
    margin-bottom: 24px;
`;

const PendingPaymentText = styled.div`
    color: #181122;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5;
    flex: 1;
`;

const VisionCard = styled.div`
    width: 200px;
    height: 100px;
    border-radius: 8px;
    background-color: rgb(230, 230, 230);
    flex-direction: column;
    display: flex;
    padding: 25px;

    @media (max-width: 745px) {
        width: 100%;
    }
`;

const ContentVisionCard = styled.div`
    display: flex;
    align-itens: center;
    flex-direction: row;
    width: 100%;
`;

const PointerVisionCard = styled.div`
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background-color: black;
    margin-top: 5px;
`;

const TextVisionCard = styled.p`
    font-family: "Montserrat";
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #181122;
    text-transform: uppercase;
    padding-left: 5px;
`;

const ValueVisionCard = styled.p`
    font-family: "Montserrat";
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #181122;
    text-transform: uppercase;
    width: 100%;
    padding-top: 10px;
`;

const PlanInfoCard = styled.div`
    min-width: ${(props) => (props.$isLegacy ? "370px" : "auto")};
    padding: 16px;
    border: 1px solid #c0c0c0;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 12px;

    @media (max-width: 480px) {
        width: 100%;
        min-width: auto;
    }
`;

const PlanInfoHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const PlanInfoIcon = styled.div`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #57c4c2;
    flex-shrink: 0;
`;

const PlanInfoTitle = styled.div`
    font-weight: 500;
    font-size: 14px;
    color: #181122;
`;

const PlanInfoFooter = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;

    @media (max-width: 440px) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

const PlanInfoPrice = styled.div`
    font-weight: 500;
    font-size: 14px;
    text-transform: uppercase;
    color: #181122;
`;

const PlanInfoLink = styled.div`
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    color: #419392;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
`;

const StatusBadge = styled.div`
    display: flex;
    padding: 2px 8px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0);
    background: #cd0000;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1),
        0 1px 2px -1px rgba(0, 0, 0, 0.1);
`;

const StatusText = styled.span`
    color: #fef2f2;
    font-family: "Montserrat";
    font-size: 12px;
    font-weight: 600;
`;

const ModalClose = styled.img`
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
`;

const ModalConfirmation = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 430px;
    height: auto;
    background-color: #ffffff;
    border-radius: 8px;
    border: 1px solid rgb(144, 144, 144);
    -webkit-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
`;

const ModalAlert = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 430px;
    height: auto;
    background-color: #ffffff;
    border-radius: 8px;
    border: 1px solid rgb(144, 144, 144);
    -webkit-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
`;

const ModalPadding = styled.div`
    padding: 20px;
`;

const Field = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
`;

const View = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 20px;
`;

const TextModal = styled.p`
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    line-height: 12px;
    border-radius: 8px;
    margin-left: 20px;
    margin-bottom: 15px;
`;

const FilterName = styled.div`
    display: flex;
    gap: 16px;
    align-itens: center;
`;

export default function Users() {
    let api = Api();
    let storage = Storage();
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_URL;
    const { impersonateCompanyId } = useImpersonation();
    const [loggedUserId, setLoggedUserId] = useState(null);
    const [firstData, setFirstData] = useState([]);
    const [filterName, setFilterName] = useState("");
    const formControl = useFormControl();
    const [rows, setRows] = useState([
        {
            id: 0,
            name: "---",
            email: "---",
            disabled: "---",
            role: "---",
            actions: {
                id: 0,
                role: 0,
                disabled: false,
            },
        },
    ]);

    const [loading, setLoading] = useState(false);

    const [status, setStatus] = useState("all");
    const [perfil, setPerfil] = useState("all");

    const [overview, setOverview] = useState({
        all: 0,
        active: 0,
        inactive: 0,
    });

    const [errorModalOpen, setErrorModalOpen] = useState(false);
    const [errorModalMessage, setErrorModalMessage] = useState("");
    const [hasPendingPayment, setHasPendingPayment] = useState(false);
    const [currentPlanName, setCurrentPlanName] = useState("free");
    const [currentPlanDescription, setCurrentPlanDescription] = useState("--");
    const [currentPlanPrice, setCurrentPlanPrice] = useState("--");
    const [planDataLoaded, setPlanDataLoaded] = useState(false);
    const [isLegacyPlan, setIsLegacyPlan] = useState(false);
    const [activeUsersCount, setActiveUsersCount] = useState(0);
    const [maxUsersAllowed, setMaxUsersAllowed] = useState(3);
    const [openUpgradeModal, setOpenUpgradeModal] = useState(false);
    const [openModalUserLimit, setOpenModalUserLimit] = useState(false);
    const [availablePlans, setAvailablePlans] = useState([]);
    const [suggestedPlan, setSuggestedPlan] = useState(null);
    const [enablePayments, setEnablePayments] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [addButtonLoading, setAddButtonLoading] = useState(true);

    function showErrorModal(message) {
        setErrorModalMessage(message);
        setErrorModalOpen(true);
    }

    function showToastMessage(message) {
        setToastMessage(message);
        setShowToast(true);
    }

    const RenderStatus = (props) => {
        const { value } = props;

        if (value === false) {
            return <Tag className="pendente">ATIVO</Tag>;
        }
        if (value === true) {
            return <Tag className="rejeitado">INATIVO</Tag>;
        }
        return <>{value}</>;
    };

    const RenderRole = (props) => {
        const { value } = props;

        if (value === 0) {
            return <Tag className="pendente">Usuário</Tag>;
        }
        if (value === 1) {
            return <Tag className="rejeitado">Administrador</Tag>;
        }
        if (value === 2) {
            return <Tag className="rejeitado">Proprietário</Tag>;
        }
        if (value === 3) {
            return <Tag className="rejeitado">Owner</Tag>;
        }
        return <>{value}</>;
    };

    const [openConfirmation, setOpenConfirmation] = useState(false);
    const [openConfirmationDeleted, setOpenConfirmationDeleted] =
        useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [disableMe, setDisableMe] = useState(false);
    const [confirmationUser, setConfirmationUser] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [profile, setProfile] = useState(null);
    const [refetchProfile, setRefetchProfile] = useState(false);
    const [companyCnpj, setCompanyCnpj] = useState("");
    const [acceptTermsOfUse, setAcceptTermsOfUse] = useState(false);
    const [selectedCells, setSelectedCells] = useState([]);
    const [hasRestrictedRole, setHasRestrictedRole] = useState(false);
    const [hasPermissionRole, setHasPermissionRole] = useState(false);
    const [openRestrictedRoleModal, setOpenRestrictedRoleModal] = useState(false);
    const [openPartialSuccessModal, setOpenPartialSuccessModal] = useState(false);
    const [openFullSuccessModal, setOpenFullSuccessModal] = useState(false);
    const [hasPermissionPlans, setHasPermissionPlans] = useState(false);

    const RenderActions = (props) => {
        const { value, row } = props;

        const userId = parseInt(row.id, 10);
        const loggedUserIdParsed = parseInt(loggedUserId, 10);

        if (value.role >= 2 || userId === loggedUserIdParsed) {
            return <></>;
        }

        if (impersonateCompanyId != null) {
            return (
                <>
                    {value.disabled && (
                        <Tooltip title="Ativar" placement="top" arrow>
                            <ImageClickable
                                src="/img/pay_paid.svg"
                                alt="Ativar"
                                style={{
                                    marginRight: 16,
                                    opacity: 0.8,
                                    pointerEvents: "none",
                                }}
                            />
                        </Tooltip>
                    )}
                    {!value.disabled && (
                        <Tooltip title="Desativar" placement="top" arrow>
                            <ImageClickable
                                src="/img/rejected.svg"
                                alt="Desativar"
                                style={{ marginRight: 16, opacity: 0.4 }}
                            />
                        </Tooltip>
                    )}
                    <Tooltip title="Deletar" placement="top" arrow>
                        <ImageClickable
                            src="/img/trash.png"
                            alt="Deletar"
                            style={{
                                marginRight: 16,
                                width: 20,
                                height: 20,
                                opacity: 0.4,
                            }}
                        />
                    </Tooltip>
                </>
            );
        }

        return (
            <>
                {value.disabled && (
                    <Tooltip title="Ativar" placement="top" arrow>
                        <ImageClickable
                            src="/img/pay_paid.svg"
                            alt="Ativar"
                            style={{ marginRight: 16 }}
                            onClick={(event) => handleRowClick(row, event)}
                        />
                    </Tooltip>
                )}
                {!value.disabled && (
                    <Tooltip title="Desativar" placement="top" arrow>
                        <ImageClickable
                            src="/img/rejected.svg"
                            alt="Desativar"
                            style={{ marginRight: 16 }}
                            onClick={(event) => handleRowClick(row, event)}
                        />
                    </Tooltip>
                )}
                <Tooltip title="Deletar" placement="top" arrow>
                    <ImageClickable
                        src="/img/trash.png"
                        alt="Deletar"
                        style={{ marginRight: 16, width: 20, height: 20 }}
                        onClick={(event) => handleRowClick(row, event)}
                    />
                </Tooltip>
            </>
        );
    };

    const handleRejectButton = () => {
        setOpenConfirmation(false);
        setOpenAlert(false);
        setOpenConfirmationDeleted(false);
        setDisableMe(false);
    };

    const columns = [
        { field: "id", headerName: "ID", width: 100 },
        { field: "name", headerName: "Nome", width: 300 },
        { field: "email", headerName: "Email", width: 300 },
        {
            field: "role",
            width: 140,
            headerName: "Perfil",
            sortable: false,
            renderCell: RenderRole,
        },
        {
            field: "disabled",
            width: 140,
            headerName: "Status",
            renderCell: RenderStatus,
        },
        {
            field: "actions",
            headerName: "Ativar/Desativar",
            sortable: false,
            disableExport: true,
            width: 150,
            renderCell: RenderActions,
        },
    ];

    const getProfile = async () => {
        const data = await storage.getItem("data");
        if (!data) return;
        const decodedUserId = atob(data.profile.id).split(":")[1];
        setLoggedUserId(decodedUserId);
        setProfile(data.profile);

        // Buscar informação de pagamento pendente e plano atual
        try {
            let response = await api.getProfile(
                data.token,
                impersonateCompanyId
            );
            const company = response?.data?.profile?.profile?.company;
            const pendingPayment = company?.hasPendingPayment || false;
            const paymentsEnabled = company?.enablePayments || false;

            // Buscar permissões da resposta da API em vez do storage local
            const permissionPlans = response?.data?.profile?.profile?.permissions?.plans || false;
            setHasPermissionPlans(permissionPlans);
            setHasPendingPayment(pendingPayment);
            setEnablePayments(paymentsEnabled);
            setCompanyCnpj(company?.cnpj || "");
            setAcceptTermsOfUse(company?.acceptTermsOfUse || false);

            if (paymentsEnabled === false) {
                setAddButtonLoading(false);
            }


            // Usar dados reais do plano do banco
            const planDescription =
                company?.subscriptionPlanDescription || "Até 3 usuários";
            const planPrice = company?.subscriptionPlanPrice || 0;
            const recurringPlanId = company?.recurringPlanId || "free";
            const usersCount = overview?.active || company?.activeUsersCount || 0;

            setCurrentPlanName(recurringPlanId);
            setActiveUsersCount(usersCount);

            // Verificar se é plano legado (free com mais de 3 usuários ativos)
            // Nota: activeUsersCount será atualizado depois pelo getUsers
            setCurrentPlanDescription(planDescription);

            // Formatar preço
            if (planPrice === 0) {
                setCurrentPlanPrice("Gratuito");
            } else {
                setCurrentPlanPrice(
                    `R$ ${planPrice.toFixed(2).replace(".", ",")}/mês`
                );
            }

            // Marcar que os dados foram carregados
            setPlanDataLoaded(true);

            // Buscar planos disponíveis apenas se payments estiver habilitado
            if (paymentsEnabled) {
                await getAvailablePlans();
            }
        } catch (error) {
            console.error("Erro ao buscar status de pagamento:", error);
            setPlanDataLoaded(true); // Marcar como carregado mesmo em caso de erro
        }
    };

    const getAvailablePlans = async () => {
        try {
            const data = await storage.getItem("data");
            if (!data) return;

            let response = await api.getAvailablePlans(
                data.token,
                impersonateCompanyId
            );

            if (response.data?.availablePlans) {
                const plans = response.data.availablePlans;
                setAvailablePlans(plans);

                // Encontrar o plano atual para saber maxUsers
                const currentPlan = plans.find((p) => p.isCurrent);
                if (currentPlan) {
                    setMaxUsersAllowed(currentPlan.maxUsers);
                }
            }
        } catch (error) {
            console.error("Erro ao buscar planos:", error);
        }
    };

    const getUsers = async () => {
        setLoading(true);
        try {
            const data = await storage.getItem("data");
            if (!data) return;
            let response = await api.getUsersFiltered(
                data.token,
                status,
                perfil,
                impersonateCompanyId
            );
            response = response.data.allZagviewUsers.edges;
            let _rows = [];
            let _all = 0;
            let _active = 0;
            let _inactive = 0;
            for (let index = 0; index < response.length; index++) {
                const user = response[index].node;
                const _user = {
                    id: parseInt(atob(user.id).split(":")[1]),
                    name: user.name,
                    email: user.email,
                    disabled: user.disabled,
                    role: user.role,
                    deleted: user.deleted,
                    company: {
                        id: parseInt(user.company.id),
                        name: user.company.name,
                    },
                    actions: {
                        id: user.id,
                        role: user.role,
                        disabled: user.disabled,
                    },
                };
                _rows.push(_user);

                // Contar todos os usuários, não apenas o primeiro
                _all = _all + 1;
                if (user.disabled) {
                    _inactive = _inactive + 1;
                } else {
                    _active = _active + 1;
                }
            }

            // Atualizar overview com a contagem completa
            setOverview({
                all: _all,
                active: _active,
                inactive: _inactive,
            });

            if (filterName) {
                const filteredRows = _rows.filter((user) =>
                    user.name.toLowerCase().includes(filterName.toLowerCase())
                );
                setRows(filteredRows);
            } else {
                setRows(_rows);
            }
            setFirstData(_rows);
        } catch (error) {
            showErrorModal(
                "Não foi possível aplicar os filtros. Verifique os dados e tente novamente."
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getUsers(status, perfil);
        getProfile();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status, perfil, refetchProfile]);

    // Verificar plano legado quando currentPlanName e overview.active mudarem
    useEffect(() => {
        if (currentPlanName === "free" && overview.active > 3) {
            setIsLegacyPlan(true);
            setCurrentPlanDescription("GRATUITO 2025 (LEGADO)");
        } else {
            setIsLegacyPlan(false);
        }
    }, [currentPlanName, overview.active]);

    const handleChangeCellSelection = (refunds) => {
        setSelectedCells(refunds);
    };

    const updateUsers = async (disabled) => {
        let _users = [];
        if (selectedCells.length > 0) {
            if (!disabled && enablePayments) {
                // Contar quantos usuários serão ativados
                const usersToActivate = selectedCells.filter((cellId) => {
                    const user = rows.find((r) => r.id === cellId);
                    return user && user.actions.disabled === true;
                }).length;

                const totalAfterActivation = activeUsersCount + usersToActivate;

                if (totalAfterActivation > maxUsersAllowed) {
                    // Verificar se o usuário tem permissão para gerenciar planos
                    if (hasPermissionPlans === false) {
                        setOpenModalUserLimit(true);
                        return;
                    }

                    // Encontrar o plano sugerido
                    const suggested = availablePlans
                        .filter((p) => p.maxUsers >= totalAfterActivation && !p.isCurrent)
                        .sort((a, b) => a.maxUsers - b.maxUsers)[0];

                    if (suggested) {
                        setSuggestedPlan(suggested);
                        setOpenUpgradeModal(true);
                    } else {
                        showErrorModal(
                            "Não há planos disponíveis que suportem mais usuários."
                        );
                    }
                    return;
                }
            }

            setLoading(true);

            if (hasRestrictedRole && !hasPermissionRole) {
                setOpenRestrictedRoleModal(true);
                setLoading(false);
            } else {
                try {
                    for (let index = 0; index < selectedCells.length; index++) {
                        const id = selectedCells[index];
                        _users.push(
                            btoa(
                                JSON.stringify({
                                    id,
                                    disabled,
                                })
                            )
                        );
                    }
                    const data = await storage.getItem("data");
                    await api.updateUsers(data.token, _users, impersonateCompanyId);
                    getUsers(status, perfil);
                } catch (error) {
                    if (disabled) {
                        showErrorModal(
                            "Não foi possível desativar em lote. \nTente novamente mais tarde."
                        );
                    } else {
                        showErrorModal(
                            "Não foi possível ativar em lote. \nTente novamente mais tarde."
                        );
                    }
                } finally {
                    if (hasRestrictedRole && hasPermissionRole) {
                        setOpenPartialSuccessModal(true);
                    } else if (hasPermissionRole) {
                        setOpenFullSuccessModal(true);
                    }
                    setLoading(false);
                }
            }
        }
    };
    const updateUser = async (id, disabled) => {
        setLoading(true);
        try {
            let _user = [
                btoa(
                    JSON.stringify({
                        id,
                        disabled,
                    })
                ),
            ];
            const data = await storage.getItem("data");
            await api.updateUsers(data.token, _user);
            getUsers(status, perfil, impersonateCompanyId);
        } catch (error) {
            if (disabled) {
                showErrorModal(
                    "Não foi possível desativar o usuário. Tente novamente mais tarde."
                );
            } else {
                showErrorModal(
                    "Não foi possível ativar o usuário. \nTente novamente mais tarde."
                );
            }
        } finally {
            setLoading(false);
        }
    };

    const deletedUser = async (email, company) => {
        setLoading(true);
        try {
            const data = await storage.getItem("data");
            await api.deletedUsers(data.token, email, company);
            getUsers(status, perfil, impersonateCompanyId);
        } catch (error) {
            showErrorModal(
                "Não foi possível deletar o usuário. \nTente novamente mais tarde."
            );
        } finally {
            setLoading(false);
        }
    };

    const [width, setWidth] = useState(window.innerWidth);
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener("resize", handleWindowSizeChange);
        window.addEventListener("load", handleWindowSizeChange);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [banks, setBanks] = useState([]);
    const [projects, setProjects] = useState([]);
    const [categories, setCategories] = useState([]);

    const getModalData = async () => {
        const data = await storage.getItem("data");
        if (!data) return;
        let response = await api.getCategories(
            data.token,
            impersonateCompanyId
        );
        response = response.data.allCategories.edges;
        let _categories = [];
        for (let index = 0; index < response.length; index++) {
            const category = response[index].node;
            _categories.push(category);
        }
        setCategories(_categories);

        response = await api.getProjects(data.token, impersonateCompanyId);
        response = response.data.allProjects.edges;
        let _projects = [];
        for (let index = 0; index < response.length; index++) {
            const project = response[index].node;
            _projects.push(project);
        }
        setProjects(_projects);

        response = await api.getBanks(data.token);
        response = response.data.allBanks.edges;
        let _banks = [];
        for (let index = 0; index < response.length; index++) {
            const bank = response[index].node;
            _banks.push(bank);
        }
        setBanks(_banks);
    };

    const [anchorElMenuAdd, setAnchorElMenuAdd] = React.useState(null);
    const openMenuAdd = Boolean(anchorElMenuAdd);
    const handleClickMenuAdd = (event) => setAnchorElMenuAdd(event.currentTarget);
    const handleCloseMenuAdd = () => {
        setAnchorElMenuAdd(null);
        setOpenAddOne(false);
        setOpenAddMultiple(false);
    };

    const [openAddOne, setOpenAddOne] = useState(false);
    const [openAddMultiple, setOpenAddMultiple] = useState(false);
    const [openEditUser, setOpenEditUser] = useState(false);

    const handleCloseModal = () => {
        setAnchorElMenuAdd(null);
        setOpenAddOne(false);
        setOpenAddMultiple(false);
        setOpenEditUser(false);
        setAddButtonLoading(false);
    };

    const handleOpenAddOne = () => {
        if (availablePlans.length === 0) {
            setAddButtonLoading(true);
        }
        // Verificar se atingiu o limite de usuários do plano (apenas se payments habilitado)
        if (enablePayments && activeUsersCount >= maxUsersAllowed) {
            // Verificar se o usuário tem permissão para gerenciar planos
            if (hasPermissionPlans === false) {
                setOpenModalUserLimit(true);
                setAnchorElMenuAdd(null);
                return;
            }

            // Encontrar o plano sugerido (que suporta activeUsersCount + 1)
            const neededUsers = activeUsersCount + 1;
            const suggested = availablePlans
                .filter((p) => p.maxUsers >= neededUsers && !p.isCurrent)
                .sort((a, b) => a.maxUsers - b.maxUsers)[0];

            if (suggested) {
                setSuggestedPlan(suggested);
                setOpenUpgradeModal(true);
                setAnchorElMenuAdd(null);
            }
        } else {
            setOpenAddOne(true);
            setOpenAddMultiple(false);
            setOpenEditUser(false);
            setAnchorElMenuAdd(null);
        }
    };

    const handleOpenAddMultiple = () => {
        setAnchorElMenuAdd(null);
        setOpenAddMultiple(true);
        setOpenAddOne(false);
        setOpenEditUser(false);
    };

    const handleOpenAlert = () => {
        setAnchorElMenuAdd(null);
        setOpenAddMultiple(false);
        setOpenAddOne(false);
        setOpenEditUser(false);
        setOpenAlert(true);
    };

    const handleCloseUpgradeModal = () => {
        setOpenUpgradeModal(false);
        setSuggestedPlan(null);
    };

    const [editUser, setEditUser] = useState();

    const generateCsv = async (users, showErrorModal) => {
        try {
            if (!Array.isArray(users) || users.length === 0) {
                showErrorModal("Não há usuários para exportar.");
                return;
            }
            const roleMap = {
                0: "user",
                1: "admin",
                2: "owner",
                3: "master",
            };

            const params = new URLSearchParams();

            let statusValue;

            if (status === true) {
                statusValue = "inactive";
            } else if (status === false) {
                statusValue = "active";
            } else {
                statusValue = "all";
            }

            params.append("status", statusValue);
            params.append("role", roleMap[perfil] || "all");
            if (filterName !== null) params.append("name", filterName);

            const url = `${API_URL}/reports/users/csv/?${params}`;

            const data = await storage.getItem("data");

            const options = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: data.token,
                },
            };

            if (impersonateCompanyId) {
                options.headers.Impersonate = impersonateCompanyId;
            }

            const response = await fetch(url, options);

            if (!response.ok) {
                if (response.status === 400) {
                    const errorMessage = await response.text();
                    throw new Error(errorMessage);
                }

                throw new Error(
                    "Erro ao gerar CSV. \nTente novamente mais tarde."
                );
            }

            const blob = await response.blob();
            const fileURL = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = fileURL;
            a.download = "zag_usuarios.csv";
            a.click();
            window.URL.revokeObjectURL(fileURL);
        } catch (error) {
            showErrorModal(
                error.message ||
                    "Não foi possível gerar o CSV. \nTente novamente mais tarde."
            );
        }
    };

    const generatePDF = async (users, showErrorModal) => {
        try {
            if (!Array.isArray(users) || users.length === 0) {
                showErrorModal("Não há usuários para exportar.");
                return;
            }
            const roleMap = {
                0: "user",
                1: "admin",
                2: "owner",
                3: "master",
            };

            const params = new URLSearchParams();

            let statusValue;

            if (status === true) {
                statusValue = "inactive";
            } else if (status === false) {
                statusValue = "active";
            } else {
                statusValue = "all";
            }

            params.append("status", statusValue);
            params.append("role", roleMap[perfil] || "all");
            if (filterName !== null) params.append("name", filterName);

            const url = `${API_URL}/reports/users/pdf/?${params}`;

            const data = await storage.getItem("data");

            const options = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: data.token,
                },
            };

            if (impersonateCompanyId) {
                options.headers.Impersonate = impersonateCompanyId;
            }

            const response = await fetch(url, options);

            if (!response.ok) {
                if (response.status === 400) {
                    const errorMessage = await response.text();
                    throw new Error(errorMessage);
                }

                throw new Error(
                    "Erro ao gerar PDF. \nTente novamente mais tarde."
                );
            }

            const blob = await response.blob();
            const fileURL = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = fileURL;
            a.download = "zag_usuarios.pdf";
            a.click();
            window.URL.revokeObjectURL(fileURL);
        } catch (error) {
            showErrorModal(
                error.message ||
                    "Não foi possível gerar o PDF. \nTente novamente mais tarde."
            );
        }
    };

    function CustomExportUsersMenu({ users, showErrorModal }) {
        const [anchorEl, setAnchorEl] = useState(null);
        const open = Boolean(anchorEl);
        const handleClick = (event) => setAnchorEl(event.currentTarget);
        const handleClose = () => setAnchorEl(null);

        return (
            <div style={{ display: "flex", alignItems: "center" }}>
                <Button
                    startIcon={<DownloadIcon />}
                    onClick={handleClick}
                    size="small"
                >
                    Exportar
                </Button>
                <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                    <MenuItem
                        onClick={() => {
                            generateCsv(users, showErrorModal);
                            handleClose();
                        }}
                    >
                        <DownloadIcon
                            fontSize="small"
                            style={{ marginRight: 8 }}
                        />
                        Exportar como CSV
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            generatePDF(users, showErrorModal);
                            handleClose();
                        }}
                    >
                        <DownloadIcon
                            fontSize="small"
                            style={{ marginRight: 8 }}
                        />
                        Exportar como PDF
                    </MenuItem>
                </Menu>
            </div>
        );
    }

    const handleOpenEditUser = async (row, event, details) => {
        setLoading(true);
        const data = await storage.getItem("data");
        const id = btoa(`ZagviewUsersWithCompanyNode:${row.id}`);
        const email = data.profile.email;

        if (row.email === email) {
            let response = await api.getUserEdit(
                data.token,
                id,
                impersonateCompanyId
            );
            setEditUser(response.data.userWithCompany);
            setAnchorElMenuAdd(null);
            setOpenAddMultiple(false);
            setOpenAddOne(false);
            setOpenEditUser(true);
        } else {
            if (row.role === 2) {
                handleOpenAlert();
            } else {
                let response = await api.getUserEdit(
                    data.token,
                    id,
                    impersonateCompanyId
                );
                setEditUser(response.data.userWithCompany);
                setAnchorElMenuAdd(null);
                setOpenAddMultiple(false);
                setOpenAddOne(false);
                setOpenEditUser(true);
            }
        }

        setLoading(false);
    };

    useEffect(() => {
        getModalData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleRowClick = async (row, event) => {
        if (event.target.nodeName !== "IMG") {
            await handleOpenEditUser(row);
        }

        if (impersonateCompanyId !== null) {
            return;
        } else {
            const actionType = event.target.alt;
            switch (actionType) {
                case "Ativar":
                    // Verificar se payments está habilitado e se há limite
                    if (enablePayments && activeUsersCount >= maxUsersAllowed) {
                        // Verificar se o usuário tem permissão para gerenciar planos
                        if (hasPermissionPlans === false) {
                            setOpenModalUserLimit(true);
                            break;
                        }

                        // Encontrar o plano sugerido
                        const neededUsers = activeUsersCount + 1;
                        const suggested = availablePlans
                            .filter((p) => p.maxUsers >= neededUsers && !p.isCurrent)
                            .sort((a, b) => a.maxUsers - b.maxUsers)[0];

                        if (suggested) {
                            setSuggestedPlan(suggested);
                            setOpenUpgradeModal(true);
                        } else {
                            showErrorModal(
                                "Não há planos disponíveis que suportem mais usuários."
                            );
                        }
                    } else {
                        setSelectedUser(row);
                        setConfirmationUser(true);
                        setOpenConfirmation(true);
                    }
                    break;
                case "Desativar":
                    if (profile && row.email === profile.email) {
                        setSelectedUser(row);
                        setDisableMe(true);
                    } else {
                        setSelectedUser(row);
                        setConfirmationUser(false);
                        setOpenConfirmation(true);
                    }
                    break;
                case "Deletar":
                    setSelectedUser(row);
                    setOpenConfirmationDeleted(true);
                    break;
                default:
                    break;
            }
        }
    };

    const logoutAndClearStorage = () => {
        storage.removeItem();
        window.location.href = "/login";
    };

    const handleSearchUser = () => {
        const filteredRows = firstData.filter((user) =>
            user.name.toLowerCase().includes(filterName.toLowerCase())
        );
        setRows(filteredRows);
    };

    const handleClear = () => {
        setRows(firstData);
        setFilterName("");
        formControl?.onBlur?.();
    };

    useEffect(() => {
        if (overview.active) {
            setActiveUsersCount(overview.active);
        }
    }, [overview?.active]);

    useEffect(() => {
        if (availablePlans.length > 0) {
            setAddButtonLoading(false);
        }
    }, [availablePlans]);

    useEffect(() => {
        if (!openModalUserLimit) {
            setAddButtonLoading(false);
        }
    }, [openModalUserLimit])

    return (
        <>
            {loading && <Loader />}

            {/* Modal de Upgrade */}
            <ModalUpgrade
                open={openUpgradeModal}
                onClose={handleCloseUpgradeModal}
                suggestedPlan={suggestedPlan}
                currentPlanName={currentPlanName}
                activeUsersCount={activeUsersCount}
                impersonateCompanyId={impersonateCompanyId}
                onUpgradeSuccess={getProfile}
                showErrorModal={showErrorModal}
                showToastMessage={showToastMessage}
                zIndex={10000}
                setRefetchProfile={setRefetchProfile}
                companyCnpj={companyCnpj}
                acceptTermsOfUse={acceptTermsOfUse}
            />

            <ModalUserLimit
                open={openModalUserLimit}
                onClose={() => setOpenModalUserLimit(false)}
                zIndex={10000}
            />

            <AddUser
                type={"one"}
                title={"Cadastrar Usuário"}
                open={openAddOne}
                close={handleCloseModal}
                banks={banks}
                projects={projects}
                categories={categories}
                getUsers={getUsers}
            />
            <AddUser
                type={"many"}
                title={"Cadastrar em Lote"}
                open={openAddMultiple}
                close={handleCloseModal}
                banks={banks}
                projects={projects}
                categories={categories}
                getUsers={getUsers}
                activeUsersCount={activeUsersCount}
                maxUsersAllowed={maxUsersAllowed}
                enablePayments={enablePayments}
                availablePlans={availablePlans}
                setSuggestedPlan={setSuggestedPlan}
                currentPlanName={currentPlanName}
                showToastMessage={showToastMessage}
                setRefetchProfile={setRefetchProfile}
                companyCnpj={companyCnpj}
                acceptTermsOfUse={acceptTermsOfUse}
            />
            {/* <EditUsers
        title={"Editar em Lote"}
        open={openEditMultiple}
        close={handleCloseModal}
        projects={projects}
        categories={categories}
        getUsers={getUsers}
      /> */}
            {editUser && (
                <EditUser
                    user={editUser}
                    title={"Editar Usuário"}
                    open={openEditUser}
                    close={handleCloseModal}
                    banks={banks}
                    projects={projects}
                    categories={categories}
                    getUsers={getUsers}
                    impersonateCompanyId={impersonateCompanyId}
                    showErrorModal={showErrorModal}
                    company={profile?.company}
                />
            )}
            <Modal
                open={openAlert}
                onClose={handleRejectButton}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <ModalAlert>
                    <ModalClose
                        src="/img/modal_close.svg"
                        onClick={handleRejectButton}
                    />
                    <ModalPadding>
                        <BasicTitle title={"Alerta"} />
                        <TextModal style={{ color: "#DE6061" }}>
                            Você não pode editar outro proprietário.
                        </TextModal>
                    </ModalPadding>
                </ModalAlert>
            </Modal>
            <Modal
                open={disableMe}
                onClose={handleRejectButton}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <ModalAlert>
                    <ModalClose
                        src="/img/modal_close.svg"
                        onClick={handleRejectButton}
                    />
                    <ModalPadding>
                        <BasicTitle title={"DESATIVAR SEU PRÓPRIO USUÁRIO"} />
                        <TextModal
                            style={{
                                fontSize: 12,
                                lineHeight: "20px",
                                marginLeft: 0,
                            }}
                        >
                            AO CLICAR EM DESATIVAR, SUA SOLICITAÇÃO SERÁ
                            EFETUADA. LEMBRE-SE, SOMENTE OUTRO ADMINISTRADOR
                            PODERÁ REATIVAR SEU PERFIL.
                        </TextModal>
                        <View>
                            <Button
                                variant="contained"
                                color={"primary"}
                                style={{ fontSize: 13 }}
                                onClick={() => {
                                    updateUser(selectedUser.id, true);
                                    setDisableMe(false);
                                    logoutAndClearStorage();
                                }}
                            >
                                DESATIVAR
                            </Button>
                        </View>
                    </ModalPadding>
                </ModalAlert>
            </Modal>
            <Modal
                open={openConfirmationDeleted}
                onClose={handleRejectButton}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <ModalConfirmation>
                    <ModalClose
                        src="/img/modal_close.svg"
                        onClick={handleRejectButton}
                    />
                    <ModalPadding>
                        <BasicTitle title={"EXCLUIR USUÁRIO"} />
                    </ModalPadding>
                    <Field>
                        <TextModal
                            style={{
                                textAlign: "left",
                                fontSize: 12,
                                lineHeight: 2,
                            }}
                        >
                            AO CLICAR EM <strong>EXCLUIR</strong>, SUA
                            SOLICITAÇÃO SERÁ
                            <br /> EFETUADA. EM CASO DE EXCLUSÃO, NÃO SERÁ
                            <br /> POSSÍVEL RECUPERAR O PERFIL.
                        </TextModal>
                        <View>
                            <Button
                                variant="contained"
                                color={"primary"}
                                style={{ fontSize: 13 }}
                                onClick={() => {
                                    deletedUser(
                                        selectedUser.email,
                                        selectedUser.company.id
                                    );
                                    setSelectedUser(null);
                                    handleRejectButton();
                                }}
                            >
                                EXCLUIR
                            </Button>
                        </View>
                    </Field>
                </ModalConfirmation>
            </Modal>
            <Modal
                open={openConfirmation}
                onClose={handleRejectButton}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <ModalConfirmation>
                    <ModalClose
                        src="/img/modal_close.svg"
                        onClick={handleRejectButton}
                    />
                    <ModalPadding>
                        <BasicTitle title={"CONFIRMAÇÃO"} />
                    </ModalPadding>
                    {confirmationUser ? (
                        <Field>
                            <TextModal style={{ textAlign: "left" }}>
                                Tem certeza que deseja reativar o usuário?
                            </TextModal>
                            <View>
                                <Button
                                    variant="contained"
                                    color={"primary"}
                                    style={{ fontSize: 13 }}
                                    onClick={() => {
                                        updateUser(selectedUser.id, false);
                                        setSelectedUser(null);
                                        handleRejectButton();
                                    }}
                                >
                                    Sim, tenho certeza
                                </Button>
                                <Button
                                    style={{
                                        color: "#DE6061",
                                        fontSize: 13,
                                    }}
                                    onClick={() => {
                                        handleRejectButton();
                                        setSelectedUser(null);
                                    }}
                                >
                                    Descartar alteração
                                </Button>
                            </View>
                        </Field>
                    ) : (
                        <Field>
                            <TextModal>
                                Tem certeza que deseja inativar o usuário?
                            </TextModal>
                            <View>
                                <Button
                                    variant="contained"
                                    color={"primary"}
                                    style={{ fontSize: 13 }}
                                    onClick={() => {
                                        updateUser(selectedUser.id, true);
                                        setSelectedUser(null);
                                        handleRejectButton();
                                    }}
                                >
                                    Sim, tenho certeza
                                </Button>
                                <Button
                                    style={{
                                        color: "#DE6061",
                                        fontSize: 13,
                                    }}
                                    onClick={() => {
                                        handleRejectButton();
                                        setSelectedUser(null);
                                    }}
                                >
                                    Descartar alteração
                                </Button>
                            </View>
                        </Field>
                    )}
                </ModalConfirmation>
            </Modal>

            <GenericModal
                open={openRestrictedRoleModal}
                onClose={() => setOpenRestrictedRoleModal(false)}
                title="Ação não permitida"
                subtitle="Sua ação não pode ser realizada pois usuários do tipo proprietários não podem ser inativados ou removidos."
                width={600}
            />

            <GenericModal
                open={openPartialSuccessModal}
                onClose={() => setOpenPartialSuccessModal(false)}
                title="Ação realizada com ressalvas"
                subtitle="Sua ação foi realizada, porém usuários do tipo proprietários não podem ser inativados ou removidos."
                width={600}
            />

            <GenericModal
                open={openFullSuccessModal}
                onClose={() => setOpenFullSuccessModal(false)}
                title="Sucesso"
                subtitle="Sua ação foi realizada com sucesso."
                width={600}
            />

            <Holder>
                <Content title={"Usuários"}>
                    {enablePayments && hasPendingPayment && hasPermissionPlans && (
                        <PendingPaymentBox>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                            >
                                <g clipPath="url(#clip0_6154_3526)">
                                    <path
                                        d="M8.00016 5.33325V7.99992M8.00016 10.6666H8.00683M14.6668 7.99992C14.6668 11.6818 11.6821 14.6666 8.00016 14.6666C4.31826 14.6666 1.3335 11.6818 1.3335 7.99992C1.3335 4.31802 4.31826 1.33325 8.00016 1.33325C11.6821 1.33325 14.6668 4.31802 14.6668 7.99992Z"
                                        stroke="#CD8200"
                                        strokeWidth="1.33"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0_6154_3526">
                                        <rect
                                            width="16"
                                            height="16"
                                            fill="white"
                                        />
                                    </clipPath>
                                </defs>
                            </svg>
                            <PendingPaymentText>
                                Estamos aguardando a confirmação do pagamento.
                                Mas fique à vontade seu acesso já está liberado!
                            </PendingPaymentText>
                        </PendingPaymentBox>
                    )}
                    <Vision>
                        <VisionBoxCard>
                            <VisionCard>
                                <ContentVisionCard>
                                    <PointerVisionCard />
                                    <TextVisionCard>Cadastrados</TextVisionCard>
                                </ContentVisionCard>
                                <ValueVisionCard>{overview.all}</ValueVisionCard>
                            </VisionCard>
                            <VisionCard>
                                <ContentVisionCard>
                                    <PointerVisionCard style={{ backgroundColor: "#57C4C2" }}/>
                                    <TextVisionCard>Ativos</TextVisionCard>
                                </ContentVisionCard>
                                <ValueVisionCard>{overview.active}</ValueVisionCard>
                            </VisionCard>
                            <VisionCard>
                                <ContentVisionCard>
                                    <PointerVisionCard style={{ backgroundColor: "#DE6061" }}/>
                                    <TextVisionCard>Inativos</TextVisionCard>
                                </ContentVisionCard>
                                <ValueVisionCard>{overview.inactive}</ValueVisionCard>
                            </VisionCard>
                        </VisionBoxCard>
                        {enablePayments && planDataLoaded && (
                            <PlanInfoCard $isLegacy={isLegacyPlan}>
                                <PlanInfoHeader>
                                    <PlanInfoIcon />
                                    <PlanInfoTitle>
                                        {isLegacyPlan
                                            ? "Plano atual: GRATUITO 2025 (LEGADO)"
                                            : `Plano atual: ${currentPlanDescription}`}
                                    </PlanInfoTitle>
                                </PlanInfoHeader>
                                {hasPermissionPlans && (
                                    <PlanInfoFooter>
                                        {isLegacyPlan ? (
                                            <StatusBadge>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="12"
                                                    height="12"
                                                    viewBox="0 0 12 12"
                                                    fill="none"
                                                >
                                                    <g clipPath="url(#clip0_6079_1623)">
                                                        <path
                                                            d="M6.00016 3.99992V5.99992M6.00016 7.99992H6.00516M10.6668 5.99992C10.6668 8.76144 8.76168 10.6666 6.00016 10.6666C3.23864 10.6666 1.3335 8.76144 1.3335 5.99992C1.3335 3.2384 3.23864 1.33325 6.00016 1.33325C8.76168 1.33325 10.6668 3.2384 10.6668 5.99992Z"
                                                            stroke="white"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_6079_1623">
                                                            <rect
                                                                width="12"
                                                                height="12"
                                                                fill="white"
                                                            />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                <StatusText>
                                                    Status: Descontinuado
                                                </StatusText>
                                            </StatusBadge>
                                        ) : (
                                            <PlanInfoPrice>
                                                {currentPlanPrice}
                                            </PlanInfoPrice>
                                        )}
                                        <PlanInfoLink
                                            onClick={() =>
                                                navigate("/settings?openPlans=true")
                                            }
                                        >
                                            ACESSAR PLANOS
                                        </PlanInfoLink>
                                    </PlanInfoFooter>
                                )}
                            </PlanInfoCard>
                        )}
                    </Vision>
                    <BasicTitle title={"Lista Completa"} />
                    <Filters
                        style={{
                            display: "flex",
                            alignItems: "flex-start",
                            flexDirection: width < 1500 ? "column" : "row",
                            gap: width < 1500 ? 16 : 0,
                        }}
                    >
                        <LeftFilters
                            style={{
                                marginBottom: width < 1000 ? 16 : 0,
                                display: width < 1000 ? "block" : "flex",
                                gap: 16,
                                width: width < 1500 ? "100%" : "auto",
                            }}
                        >
                            <FilterName
                                style={{
                                    display: "flex",
                                    gap: 16,
                                    alignItems: "center",
                                }}
                            >
                                <FormControl
                                    style={{
                                        width: width < 1000 ? "100%" : 200,
                                    }}
                                    size="small"
                                >
                                    <TextField
                                        id="outlined-basic"
                                        label="Nome"
                                        variant="outlined"
                                        size="small"
                                        style={{ borderRadius: 5 }}
                                        value={filterName}
                                        onChange={(event) => {
                                            setFilterName(event.target.value);
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                                handleSearchUser();
                                            }
                                        }}
                                        InputProps={{
                                            endAdornment: filterName ? (
                                                <IconButton
                                                    style={{
                                                        position: "absolute",
                                                        right: 12,
                                                    }}
                                                    onClick={() =>
                                                        handleClear()
                                                    }
                                                    edge="end"
                                                >
                                                    <ClearIcon />
                                                </IconButton>
                                            ) : null,
                                        }}
                                    />
                                </FormControl>
                                <Button
                                    style={{
                                        fontSize: 12,
                                        padding: "0px",
                                        height: 40,
                                        borderRadius: 8,
                                    }}
                                    variant="contained"
                                    disableelevation="true"
                                    color="primary"
                                    onClick={handleSearchUser}
                                    disabled={!filterName}
                                >
                                    <img
                                        src="/img/search.svg"
                                        alt="Filtro"
                                        style={{ width: 20, height: 20 }}
                                    />
                                </Button>
                            </FilterName>
                            <div
                                style={{
                                    display: "flex",
                                    gap: 16,
                                    marginTop: width < 1000 ? 16 : 0,
                                }}
                            >
                                <FormControl
                                    style={{
                                        width: width < 1000 ? "100%" : 200,
                                    }}
                                    size="small"
                                >
                                    <InputLabel>Status</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        defaultValue={status}
                                        label="Status"
                                        onChange={(event) => {
                                            setStatus(event.target.value);
                                        }}
                                    >
                                        <MenuItem value={"all"}>Todos</MenuItem>
                                        <MenuItem value={false}>Ativo</MenuItem>
                                        <MenuItem value={true}>
                                            Inativo
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                                <FormControl
                                    style={{
                                        width: width < 1000 ? "100%" : 200,
                                    }}
                                    size="small"
                                >
                                    <InputLabel>Perfil</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        defaultValue={perfil}
                                        label="Perfil"
                                        onChange={(event) => {
                                            setPerfil(event.target.value);
                                        }}
                                    >
                                        <MenuItem value={"all"}>Todos</MenuItem>
                                        <MenuItem value={0}>Usuário</MenuItem>
                                        <MenuItem value={1}>
                                            Administrador
                                        </MenuItem>
                                        <MenuItem value={2}>
                                            Proprietário
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                        </LeftFilters>
                        <RightFilters
                            style={{
                                display: width < 1000 ? "block" : "flex",
                                width: width < 1500 ? "100%" : "auto",
                            }}
                        >
                            <div>
                                {impersonateCompanyId === null ? (
                                    <Button
                                        style={{
                                            // marginLeft: width < 1000 ? 0 : 16,
                                            marginBottom: width < 1000 ? 16 : 0,
                                            width: width < 1000 ? "100%" : 150,
                                            fontSize: 12,
                                            padding: "8px 0px",
                                        }}
                                        variant="contained"
                                        color={"primary"}
                                        onClick={handleClickMenuAdd}
                                        disabled={addButtonLoading}
                                    >
                                        {addButtonLoading ? (
                                            <CircularProgress size={20} color="inherit" />
                                        ) : (
                                            "+ ADICIONAR"
                                        )}
                                    </Button>
                                ) : (
                                    <Button
                                        style={{
                                            marginLeft: width < 1000 ? 0 : 16,
                                            marginBottom: width < 1000 ? 16 : 0,
                                            width: width < 1000 ? "100%" : 150,
                                            fontSize: 12,
                                            padding: "8px 0px",
                                        }}
                                        variant="outlined"
                                        color={"primary"}
                                    >
                                        + ADICIONAR
                                    </Button>
                                )}
                                <Menu
                                    id="basic-menu"
                                    anchorEl={anchorElMenuAdd}
                                    open={openMenuAdd}
                                    onClose={handleCloseMenuAdd}
                                    MenuListProps={{
                                        "aria-labelledby": "basic-button",
                                    }}
                                >
                                    <MenuItem onClick={handleOpenAddOne}>
                                        Cadastro Único
                                    </MenuItem>
                                    <MenuItem onClick={handleOpenAddMultiple}>
                                        Cadastro em Lote
                                    </MenuItem>
                                </Menu>
                            </div>
                            {/* <Button
                                style={{
                                marginLeft: width < 1000 ? 0 : 16,
                                marginBottom: width < 1000 ? 16 : 0,
                                width: width < 1000 ? "100%" : 200,
                                fontSize: 12,
                                padding: "8px 0px",
                                // opacity: selectedCells.length > 0 ? 1 : 0.4,
                                }}
                                variant="contained"
                                color={"primary"}
                                onClick={() => {
                                setOpenEditMultiple(true);
                                }}
                                startIcon={<img src="/img/pencil.svg" alt="Editar" />}
                            >
                                EDITAR EM LOTE
                            </Button> */}
                            {impersonateCompanyId === null ? (
                                <div
                                    style={{
                                        display:
                                            width < 1000 ? "block" : "flex",
                                    }}
                                >
                                    <Button
                                        style={{
                                            marginLeft: width < 1000 ? 0 : 16,
                                            marginBottom: width < 1000 ? 16 : 0,
                                            width: width < 1000 ? "100%" : 150,
                                            fontSize: 12,
                                            padding: "8px 0px",
                                            opacity:
                                                selectedCells.length > 0
                                                    ? 1
                                                    : 0.4,
                                        }}
                                        variant="outlined"
                                        color="secondary"
                                        onClick={() => {
                                            updateUsers(false);
                                        }}
                                    >
                                        ATIVAR EM LOTE
                                    </Button>
                                    <Button
                                        style={{
                                            marginLeft: width < 1000 ? 0 : 16,
                                            marginBottom: width < 1000 ? 16 : 0,
                                            width: width < 1000 ? "100%" : 180,
                                            fontSize: 12,
                                            padding: "8px 0px",
                                            opacity:
                                                selectedCells.length > 0
                                                    ? 1
                                                    : 0.4,
                                        }}
                                        variant="outlined"
                                        color={
                                            selectedCells.length > 0
                                                ? "error"
                                                : "secondary"
                                        }
                                        onClick={() => {
                                            updateUsers(true);
                                        }}
                                    >
                                        DESATIVAR EM LOTE
                                    </Button>
                                </div>
                            ) : (
                                <div
                                    style={{
                                        display:
                                            width < 1000 ? "block" : "flex",
                                    }}
                                >
                                    <Button
                                        style={{
                                            marginLeft: width < 1000 ? 0 : 16,
                                            marginBottom: width < 1000 ? 16 : 0,
                                            width: width < 1000 ? "100%" : 150,
                                            fontSize: 12,
                                            padding: "8px 0px",
                                        }}
                                        variant="outlined"
                                        color="primary"
                                    >
                                        ATIVAR EM LOTE
                                    </Button>
                                    <Button
                                        style={{
                                            marginLeft: width < 1000 ? 0 : 16,
                                            marginBottom: width < 1000 ? 16 : 0,
                                            width: width < 1000 ? "100%" : 180,
                                            fontSize: 12,
                                            padding: "8px 0px",
                                        }}
                                        variant="outlined"
                                        color="primary"
                                    >
                                        DESATIVAR EM LOTE
                                    </Button>
                                </div>
                            )}
                        </RightFilters>
                    </Filters>
                    <Data style={{ marginBottom: 100 }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            className={"hover"}
                            initialState={{
                                pagination: {
                                    paginationModel: { pageSize: 20 },
                                },
                            }}
                            // onCellClick={(
                            //   params: GridCellParams,
                            //   event: MuiEvent<React.MouseEvent>
                            // ) => {
                            //   event.defaultMuiPrevented = true;
                            // }}
                            pageSizeOptions={[20, 50, 100]}
                            checkboxSelection
                            disableRowSelectionOnClick
                            onRowSelectionModelChange={(selectedIds) => {
                                const selectedRowsData = rows.filter(row =>
                                    selectedIds.includes(row.id)
                                );

                                setHasRestrictedRole(selectedRowsData.some(row =>
                                    row.role === 2 || row.role === 3
                                ));

                                setHasPermissionRole(selectedRowsData.some(row =>
                                    row.role === 0 || row.role === 1
                                ));

                                handleChangeCellSelection(selectedIds);
                            }}
                            slots={{
                                toolbar: () => (
                                    <CustomExportUsersMenu
                                        users={rows}
                                        showErrorModal={showErrorModal}
                                    />
                                ),
                            }}
                            sx={{
                                "@media print": {
                                    zoom: "75%",
                                },
                            }}
                            onRowClick={(params, event) =>
                                handleRowClick(params.row, event)
                            }
                        />
                    </Data>
                </Content>

                <ErrorModal
                    open={errorModalOpen}
                    onClose={() => setErrorModalOpen(false)}
                    message={errorModalMessage}
                />

                {showToast && (
                    <Toast
                        message={toastMessage}
                        onClose={() => setShowToast(false)}
                    />
                )}
            </Holder>
        </>
    );
}
